import { Button, Typography, styled } from "@mui/material";

export const Btn = styled(Button)(({ theme }) => ({
  fontFamily: "Poppins",
  fontWeight: 400,
  fontSize: "16px",
  color: "#959595",
  boxShadow: "none",
  textTransform: "none",
  background: "#ffffff !important",
  borderRadius: "0px",
  [theme.breakpoints.down("md")]: {
    fontSize: "12px",
  },
}));
export const MenuTitle = styled(Typography)(({ theme }) => ({
  fontFamily: "Poppins",
  fontWeight: 600,
  fontSize: "14px",
  color: "#60656C",
  textTransform: "none",
}));
